import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeLanguagePreference,
  changeApplicationLanguage,
} from "../../redux/modules/language/actions";
import brazilFlag from "../../assets/images/brazil-flag.png";
import ukFlag from "../../assets/images/uk-flag.png";
import {
  Container,
  SelectedLanguage,
  DropdownContainer,
  LanguageOption,
  Flag,
  LanguageText,
} from "./styles";
import { Tooltip } from "antd";

const languages = [
  { code: "pt", flag: brazilFlag, text: "Português" },
  { code: "en", flag: ukFlag, text: "English" },
];

const LanguageSelector = ({ className, style }) => {
  const dispatch = useDispatch();
  const { code } = useSelector((state) => state.language);
  const { token } = useSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);
  const [activeFlag, setActiveFlag] = useState(ukFlag);
  const containerRef = useRef(null);

  useEffect(() => {
    const language = languages.find((language) => language.code === code);
    if (language) {
      setActiveFlag(language.flag);
    }
  }, [code]);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleLanguageChange = (language) => {
    if (token) {
      // Se tiver token (usuário autenticado), usa a preference que salva no backend
      dispatch(
        changeLanguagePreference({
          code: language,
          token: token,
        }),
      );
    } else {
      // Se não tiver token (página de login), apenas muda o idioma da aplicação
      dispatch(
        changeApplicationLanguage({
          code: language,
        }),
      );
    }
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Container ref={containerRef} className={className} style={style}>
      <Tooltip title={code === "pt" ? "Idioma" : "Language"}>
        <SelectedLanguage onClick={toggleDropdown}>
          <Flag src={activeFlag} alt="Current language flag" />
        </SelectedLanguage>
      </Tooltip>

      {isOpen && (
        <DropdownContainer>
          {languages.map((language) => (
            <LanguageOption
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              $isActive={code === language.code}
            >
              <Flag src={language.flag} alt={`${language.text} flag`} />
              <LanguageText>{language.text}</LanguageText>
            </LanguageOption>
          ))}
        </DropdownContainer>
      )}
    </Container>
  );
};

export default LanguageSelector;
